import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { PhoneApi } from './PersonPhoneApi';
import { PrivacyApi } from './PersonPrivacyApi';
import { ContractApi } from './PersonContractApi';
import { BankverbindungApi } from './PersonBankverbindungApi';
import { AddressApi } from './PersonAddressApi';
import { AnredeArtApi } from './InterfacesAnredeArtApi';

/**
 * APIL Url: ADAC.Internet.Interfaces.IUserExt
 * 
 * Endpoints: /api/Identity
 */
export class IUserExtApi extends BaseApiModel {
	constructor(initialProperties?: Partial<IUserExtApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected alter: number;
	/**
	 * Description: 
	 * APIL Type: double
	 */
	get Alter(): number {
		return this.alter;
	}

	/**
	 * Description: 
	 * APIL Type: double
	 */
	set Alter(value: number) {
		this.alter = value;
	}

	protected telefon: PhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	get Telefon(): PhoneApi {
		return this.telefon;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	set Telefon(value: PhoneApi) {
		this.telefon = value;
	}

	protected telGesch: PhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	get TelGesch(): PhoneApi {
		return this.telGesch;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	set TelGesch(value: PhoneApi) {
		this.telGesch = value;
	}

	protected fax: PhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	get Fax(): PhoneApi {
		return this.fax;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	set Fax(value: PhoneApi) {
		this.fax = value;
	}

	protected email: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Email(): string {
		return this.email;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Email(value: string) {
		this.email = value;
	}

	protected datenverwendung: PrivacyApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Privacy
	 */
	get Datenverwendung(): PrivacyApi {
		return this.datenverwendung;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Privacy
	 */
	set Datenverwendung(value: PrivacyApi) {
		this.datenverwendung = value;
	}

	protected mitgliedschaft: ContractApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Contract
	 */
	get Mitgliedschaft(): ContractApi {
		return this.mitgliedschaft;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Contract
	 */
	set Mitgliedschaft(value: ContractApi) {
		this.mitgliedschaft = value;
	}

	protected bankdaten: BankverbindungApi[];
	/**
	 * Description: 
	 * APIL Type: Collection<ADAC.Internet.Types.Person.Bankverbindung>
	 */
	get Bankdaten(): BankverbindungApi[] {
		return this.bankdaten;
	}

	/**
	 * Description: 
	 * APIL Type: Collection<ADAC.Internet.Types.Person.Bankverbindung>
	 */
	set Bankdaten(value: BankverbindungApi[]) {
		this.bankdaten = value;
	}

	protected istMitglied: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get IstMitglied(): boolean {
		return this.istMitglied;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set IstMitglied(value: boolean) {
		this.istMitglied = value;
	}

	protected istVitaKunde: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get IstVitaKunde(): boolean {
		return this.istVitaKunde;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set IstVitaKunde(value: boolean) {
		this.istVitaKunde = value;
	}

	protected tarifFuerMitgliedschaft: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get TarifFuerMitgliedschaft(): boolean {
		return this.tarifFuerMitgliedschaft;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set TarifFuerMitgliedschaft(value: boolean) {
		this.tarifFuerMitgliedschaft = value;
	}

	protected fremdKunde: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get FremdKunde(): boolean {
		return this.fremdKunde;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set FremdKunde(value: boolean) {
		this.fremdKunde = value;
	}

	protected kundeIstInaktiv: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get KundeIstInaktiv(): boolean {
		return this.kundeIstInaktiv;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set KundeIstInaktiv(value: boolean) {
		this.kundeIstInaktiv = value;
	}

	protected verifiedWithIdentityChecked: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get VerifiedWithIdentityChecked(): boolean {
		return this.verifiedWithIdentityChecked;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set VerifiedWithIdentityChecked(value: boolean) {
		this.verifiedWithIdentityChecked = value;
	}

	protected fullHostName: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get FullHostName(): string {
		return this.fullHostName;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set FullHostName(value: string) {
		this.fullHostName = value;
	}

	protected vornameLegacy: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get VornameLegacy(): string {
		return this.vornameLegacy;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set VornameLegacy(value: string) {
		this.vornameLegacy = value;
	}

	protected nachnameLegacy: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get NachnameLegacy(): string {
		return this.nachnameLegacy;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set NachnameLegacy(value: string) {
		this.nachnameLegacy = value;
	}

	protected firmaLegacy: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get FirmaLegacy(): string {
		return this.firmaLegacy;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set FirmaLegacy(value: string) {
		this.firmaLegacy = value;
	}

	protected anschrift: AddressApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Address
	 */
	get Anschrift(): AddressApi {
		return this.anschrift;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Address
	 */
	set Anschrift(value: AddressApi) {
		this.anschrift = value;
	}

	protected anrede: AnredeArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.AnredeArt
	 */
	get Anrede(): AnredeArtApi {
		return this.anrede;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.AnredeArt
	 */
	set Anrede(value: AnredeArtApi) {
		this.anrede = value;
	}

	protected firma: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Firma(): string {
		return this.firma;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Firma(value: string) {
		this.firma = value;
	}

	protected titel: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Titel(): string {
		return this.titel;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Titel(value: string) {
		this.titel = value;
	}

	protected vorname: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Vorname(): string {
		return this.vorname;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Vorname(value: string) {
		this.vorname = value;
	}

	protected nachname: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Nachname(): string {
		return this.nachname;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Nachname(value: string) {
		this.nachname = value;
	}

	protected beguenstigter: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Beguenstigter(): string {
		return this.beguenstigter;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Beguenstigter(value: string) {
		this.beguenstigter = value;
	}

	protected geburtsdatum: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get Geburtsdatum(): string {
		return this.geburtsdatum;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set Geburtsdatum(value: string) {
		this.geburtsdatum = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): IUserExtApi {
		return AppUtils.Helper.createFromMap(dataObject, IUserExtApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'telefon':
					return PhoneApi.createFromObject(value);
				case 'telgesch':
					return PhoneApi.createFromObject(value);
				case 'fax':
					return PhoneApi.createFromObject(value);
				case 'datenverwendung':
					return PrivacyApi.createFromObject(value);
				case 'mitgliedschaft':
					return ContractApi.createFromObject(value);
				case 'bankdaten':
					const resultbankdaten = new Array<BankverbindungApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultbankdaten.push(BankverbindungApi.createFromObject(v));
						});
					}
					return resultbankdaten;
				case 'anschrift':
					return AddressApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Alter = this.alter;
		if (this.telefon) {
			result.Telefon = this.telefon.toRequestObject();
		}
		if (this.telGesch) {
			result.TelGesch = this.telGesch.toRequestObject();
		}
		if (this.fax) {
			result.Fax = this.fax.toRequestObject();
		}
		result.Email = this.email;
		if (this.datenverwendung) {
			result.Datenverwendung = this.datenverwendung.toRequestObject();
		}
		if (this.mitgliedschaft) {
			result.Mitgliedschaft = this.mitgliedschaft.toRequestObject();
		}
		const bankdatenArrayReqObject: object[] = [];
		this.bankdaten.forEach((element) => {
			bankdatenArrayReqObject.push(element.toRequestObject());
		});
		result.Bankdaten = bankdatenArrayReqObject;
		result.IstMitglied = this.istMitglied;
		result.IstVitaKunde = this.istVitaKunde;
		result.TarifFuerMitgliedschaft = this.tarifFuerMitgliedschaft;
		result.FremdKunde = this.fremdKunde;
		result.KundeIstInaktiv = this.kundeIstInaktiv;
		result.VerifiedWithIdentityChecked = this.verifiedWithIdentityChecked;
		result.FullHostName = this.fullHostName;
		result.VornameLegacy = this.vornameLegacy;
		result.NachnameLegacy = this.nachnameLegacy;
		result.FirmaLegacy = this.firmaLegacy;
		if (this.anschrift) {
			result.Anschrift = this.anschrift.toRequestObject();
		}
		result.Anrede = this.anrede;
		result.Firma = this.firma;
		result.Titel = this.titel;
		result.Vorname = this.vorname;
		result.Nachname = this.nachname;
		result.Beguenstigter = this.beguenstigter;
		result.Geburtsdatum = this.geburtsdatum;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}